import { AbstractCustomTableToolsPanel } from "./AbstractCustomTableToolsPanel";

export class CustomLeftTableToolsPanel extends AbstractCustomTableToolsPanel {
    override getPopulatedPaddingLeft(): number {
        return 0;
    }

    override getPopulatedPaddingRight(): number {
        return 4;
    }
}
